import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {QueueDirectorySync as QueueDirectorySyncMutation} from 'nutshell-graphql-types';

import QUEUE_DIRECTORY_SYNC from '../mutations/queue-directory-sync.graphql';

export const useQueueDirectorySync = (): {
    queueDirectorySync: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [queueDirectorySync, {loading, error}] = useMutation<
        QueueDirectorySyncMutation,
        Record<any, any>
    >(QUEUE_DIRECTORY_SYNC);

    return {
        queueDirectorySync: () => {
            return queueDirectorySync();
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
